// import React from "react";

// export default function useOutsideClick(callback) {
//     const ref = React.useRef();

//     React.useEffect(() => {
//         const handleClick = (event) => {
//             if (ref.current && !ref.current.contains(event.target)) {
//                 callback();
//             }
//         };

//         document.addEventListener('click', handleClick, true);

//         return () => {
//             document.removeEventListener('click', handleClick, true);
//         };
//     }, [ref]);

//     return ref;
// };

import React from "react";

export default function useOutsideClick(ref, callback) {
    React.useEffect(() => {
        const handleClick = (event) => {
            const clickedSelectPortal = event.target.closest?.(
                '.solyntek-select__menu-portal'
            );

            if (
                ref.current
                && !ref.current.contains(event.target)
                && !clickedSelectPortal
            ) {
                callback();
            }
        };

        document.addEventListener('click', handleClick, true);

        return () => {
            document.removeEventListener('click', handleClick, true);
        };
    }, [ref, callback]);
};
